import { Routes, Route } from "react-router";
import SimProviderAccountsMain from './views/main';
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security"
const SimProviderView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "simpa") && <Route path="list" element={<SimProviderAccountsMain />} />}
            </Routes>
        </>
    )
}
export default SimProviderView